/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { IncidentLogConfigurationDto } from '../../models/incident-log-configuration-dto';

export interface IncidentLogConfigurationUpdatePaperConsignmentConfiguration$Params {
      body: IncidentLogConfigurationDto
}

export function incidentLogConfigurationUpdatePaperConsignmentConfiguration(http: HttpClient, rootUrl: string, params: IncidentLogConfigurationUpdatePaperConsignmentConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<IncidentLogConfigurationDto>> {
  const rb = new RequestBuilder(rootUrl, incidentLogConfigurationUpdatePaperConsignmentConfiguration.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<IncidentLogConfigurationDto>;
    })
  );
}

incidentLogConfigurationUpdatePaperConsignmentConfiguration.PATH = '/incident-log/configuration';